import React from 'react';
import './styles/main.scss';

function routesConfig(pages) {
  const [ConversationalCarleadPage] = pages;

  return [
    {
      path: `/`,
      exact: true,
      component: ConversationalCarleadPage,
      // Required for RUM
      componentName: 'ConversationalCarleadPage',
    },
    {
      // there is no need to declare path variable
      // react router will pick this component as fallback
      component: () => <div></div>,
      componentName: 'notFoundPage',
    },
  ];
}

export default routesConfig;
